import { IconButton, IconButtonProps } from "@mui/material";

export const VideoOverlayIconButton = (
  props: Omit<IconButtonProps, "size" | "sx">
) => (
  <IconButton
    {...props}
    size="small"
    sx={{
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      color: "white",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.85)",
      },
    }}
  />
);
